const colors = {
  $primaryColor: "#014751",
  $white: "#ffffff",
  $secondaryColor: "#E2BB53",
  $black: "black",
};

export default colors;
